export const LogoMark = ({ className = "h-9 w-9" }) => (
  <img src="/img/logo-sm.jpg" alt="S'Designer" className={`${className} rounded-[28%] border border-[#163D43] object-cover`} />
);

export const Logo = () => (
  <span className="flex items-center gap-3">
    <LogoMark />
    <span className="font-display text-lg font-semibold tracking-tight text-teal-50">
      S'Designer<span className="text-[#2DD4BF]">.</span>
    </span>
  </span>
);
